<template>
    <div class="columns is-multiline">
        <div class="column is-9 pb-0">
            <div
                class="project-search field has-addons lb-search-bar is-expanded"
            >
                <p class="control has-icons-left lb-clean-input is-expanded">
                    <input
                        :placeholder="$t('search')"
                        class="input"
                        type="text"
                        @input="$emit('input', $event.target.value)"
                    />
                    <span class="icon is-small is-left">
                        <i class="mdi mdi-24px mdi-magnify"></i>
                    </span>
                </p>
                <div class="control">
                    <app-dropdown-filter
                        :options="availablefilters"
                        :filter.sync="selectedFilter"
                        :active="dropdownActive"
                        class="is-right lb-clean-input"
                        @click="dropdownActive = !dropdownActive"
                    />
                </div>
            </div>
        </div>
        <!--<div
            :class="{ 'is-full-tablet': windowSize === 'tablet' }"
            class="column is-narrow is-12"
        >
            <div class="field is-grouped is-grouped-multiline">
                <div
                    class="control"
                    v-for="option in availablefilters"
                    :key="option"
                >
                    <div class="tags">
                        <span
                            class="tag is-size-6 py-2"
                            :class="
                                isActive(option) ? 'is-pink-red' : 'is-primary'
                            "
                            @click="selectFilter(option)"
                            ><i
                                class="mdi mdi-16px mdi-check-bold mr-2"
                                v-if="isActive(option)"
                            ></i
                            >{{ $t(`Constants.${option}`) }}</span
                        >
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
import NAppButtonsFilter from '@/components/NAppButtonsFilter';
import AppDropdownFilter from '@/components/AppDropdownFilter';
import _ from 'underscore';
import {
    ADMIN_FILTER_PROJECT_TYPES,
    USER_FILTER_PROJECT_TYPES,
} from '@/lib/constants';
export default {
    components: {
        NAppButtonsFilter,
        AppDropdownFilter,
    },
    model: 'text',
    props: {
        text: {
            type: String,
            default: '',
        },
        filters: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dropdownActive: false,
            selectedFilter: '',
            /*buttons: [
                this.$t('Constants.FILTER_OPTION_ALL'),
                this.$t('Constants.FILTER_OPTION_PROJECTS_INVITED'),
                this.$t('Constants.FILTER_OPTION_PROJECTS_PARTICIPATED'),
            ],*/
        };
    },
    computed: {
        windowSize() {
            return this.$mq;
        },
        availablefilters() {
            if (this.isAdmin) {
                return ADMIN_FILTER_PROJECT_TYPES;
            } else {
                return USER_FILTER_PROJECT_TYPES;
            }
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
    },
    watch: {
        selectedFilter() {
            // console.log("changin filter to ",this.selectedFilter)
            this.$emit('change-filter', this.selectedFilter);
        },
        /*activeFilters() {
            console.log(this.activeFilters);
            this.$emit('update:filters', this.activeFilters);
        },*/
    },
    methods: {
        selectFilter(option) {
            if (this.loading) {
                return;
            }
            let activeFilters = [...this.filters];
            if (this.isActive(option)) {
                activeFilters = _.without(this.filters, option);
            } else {
                activeFilters.push(option);
            }
            this.$emit('update:filters', activeFilters);
        },
        isActive(filter) {
            //console.log(filter);
            return _.contains(this.filters, filter);
        },
    },
};
</script>


